<template>
    <div>
        <div class="hero">
            <div class="hero-body">
                <div class="container">
                    <h1 class="title">
                        <span v-if="$route.name === 'admins'">Admins</span>
                        <span v-if="$route.name === 'admin'">
                            <router-link :to="{name: 'admins'}">Admins</router-link>
                            &rarr;
                            {{ getAdmin().first_name }} {{ getAdmin().last_name }}
                        </span>
                        <span v-if="$route.name === 'admin-create'">
                            <router-link :to="{name: 'admins'}">Admins</router-link>
                            &rarr;
                            New Admin
                        </span>
                    </h1>
                </div>
            </div>
        </div>
        <div class="container content">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    export default {
        data() {
            return {}
        },
        computed: mapGetters(['admins']),
        methods: {
            getAdmin() {
                return this.admins.find(admin => admin.id === parseInt(this.$route.params.id))
            }
        }
    };
</script>



// WEBPACK FOOTER //
// Admins.vue?13d186d6